module.exports = __webpack_public_path__ + "img/se.20eb11c7.svg";